import { translation } from './en';

export const family = {
  'common': translation.common,
  'components': translation.components,
  'pages': {
    'nux': {
      'family': {
        'location': {
          'title': 'Where are you looking for care?',
          'titleJustBrowsing': 'Just browsing?\nShare your location to explore local caregivers.',
          'city': 'City',
          'state': 'State',
          'neighborhood': 'Neighborhood (optional)',
          'infoCard': {
            'title': 'How we use this info',
            'description': 'Location is used to find nearby, reliable care. Your street address will only ever be shared when you book a caregiver.'
          }
        },
        'locationErrors': {
          'errorUpdatingAddress': 'Error updating address.',
          'errorSavingSearch': 'Error saving search.',
          'errorDeletingSearch': 'Error deleting saved search.'
        },
      },
    },
    'bookingConfirmPayment': {
      'titleSame': 'Confirm payment for {{name}}',
      'subtitleSame': '{{name}} expects the payment for your booking on {{date}}.',
      'reviewAddTip': 'Please review for accuracy and add an optional tip.',
      'reviewAccuracyOnly': 'Please review for accuracy.',
      'subtitleMorePrefix': '{{name}} confirmed working {{date}}. To use these confirmed hours, contact',
      'subtitleLess': '{{name}} confirmed working less time on {{date}} than originally booked.',
      'confirmedTime': 'Confirmed time:',
      'useBookedHours': 'Use originally booked hours',
      'useConfirmedHours': 'Use confirmed hours',
      'startTime': 'Start Time',
      'endTime': 'End Time',
      'service': 'Service',
      'workingInterview': 'Working interview',
      'perHour': '${{rate}} /hr',
      'flatRate': 'flat rate of ${{rate}}',
      'platformFee': 'Platform Fee',
      'platformFeePercent': '3% of subtotal',
      'platformFeeTip': "Rest assured, caregivers keep 100% of their earnings with UrbanSitter's standard payouts.",
      'subtotal': 'Subtotal',
      'addTip': 'Add tip',
      'total': 'Total',
      'messageTo': 'Message to {{name}} (Optional)',
      'messagePlaceholder': 'Message to {{name}}',
      'policyCertify': 'I certify that to my knowledge, this booking was for qualified services from a care provider that meets the guidelines communicated to me by my employer.',
      'viewEmployerPolicy': 'View employer policy',
      'submitting': 'Submitting...',
      'payNow': 'Pay now',
      'doubleCheck': 'Please double-check before sending as all fees and charges are nonrefundable.',
      'cardWillCharge': 'Your card will be charged once you pay.',
      'disagreeContact': 'If you disagree with the hours confirmed, please contact',
      'confirmModalTitle': 'Confirm Payment',
      'caregiverWillReceive': '{{name}} will receive ${{amount}} for this job.',
      'creditApplied': '${{amount}} in credit will be applied.',
      'cardWillBeCharged': 'Your card will be charged ${{amount}}.',
      'yesConfirm': 'Yes, Pay Now',
      'removeVoucherTitle': 'Remove discount?',
      'removeVoucherBody': 'Are you sure you want to remove this discount from the booking?',
      'removeVoucherConfirm': 'Remove discount',
      'removeDiscountAriaLabel': 'Remove discount',
      'closeModalAriaLabel': 'Close modal',
      'voucherFallback': 'Voucher #{{id}}',
      'discountRemoved': 'Discount removed.',
      'discountRemoveError': "Couldn't remove discount. Try again.",
      'submitFailed': "Couldn't confirm payment. Try again.",
      'cannotConfirmYet': 'This booking is not ready to confirm payment yet.',
      'alreadyConfirmed': 'This booking has already been confirmed.'
    },
    'jobDetail': {
      'closeModal': {
        'title': 'Close this job',
        'legend': 'Why are you closing this job?',
        'option1': "I've found a sitter through UrbanSitter",
        'option2': "I've found a sitter, but not through UrbanSitter",
        'option3': "I've decided I don't need a sitter anymore",
        'option4': 'This job post is no longer valid',
        'footer': 'Note: closing a job post will remove it from public search results and prevent caregivers from applying.',
        'submit': 'Close job',
        'validationError': 'Please select a reason.',
        'submitError': "Couldn't close job. Try again."
      }
    },
    'messageThread': {
      'messageNameHeading': 'Message {{name}}',
      'startConversation': 'Start a conversation',
      'viewPrevious': 'View previous messages',
      'typeMessage': 'Type a message to {{name}}...',
      'messageLabelTo': 'Message to {{name}}',
      'sendAriaLabel': 'Send message',
      'hiddenHeading': 'Hidden Profile',
      'hiddenBody': 'Your message cannot be sent because your profile is currently hidden. Buy a membership now or email us if you have questions: support@urbansitter.com',
      'hiddenOk': 'OK',
      'sendFailed': "Couldn't send message. Try again.",
      'bookAgain': 'Book Again',
      'book': 'Book',
      'interview': 'Interview',
      'closeModalAriaLabel': 'Close modal'
    },
    'parentBookingWizard': {
      'deferred': 'Booking step not yet implemented.',
      'frequency': {
        'heading': 'When do you need this care?',
        'justOnce': 'Just once',
        'justOnceBody': 'Send a booking request for a specific date and time',
        'recurring': 'On a recurring basis',
        'recurringBody': 'Send multiple booking requests based on a recurring schedule'
      },
      'selection': {
        'usePostHeading': 'Want to use details from an active job post?',
        'createNewBooking': 'Create a new job booking',
        'viewMore': 'View more posts',
        'heading': 'What care does your family need?',
        'recurringWithStart': '{{availability}}, starting {{date}}',
        'perHour': '${{rate}} per hour',
        'interestWarningTitle': 'Heads up',
        'interestWarningBody1': 'This caregiver did not express interest in your job at your preferred rate and payment method.',
        'interestWarningBody2': "If you proceed, you'll be required to pay this caregiver at their minimum hourly rate or higher, would you like to proceed?",
        'interestWarningBody2WithRate': "If you proceed, you'll be required to pay this caregiver at their minimum hourly rate (${{rate}}/hr) or higher, would you like to proceed?",
        'careTypes': {
          'childCare': 'Child Care',
          'childCareBody': 'Backup, occasional, part- or full-time sitters and nannies',
          'seniorCare': 'Senior Care',
          'seniorCareBody': 'Non-medical companion care',
          'petCare': 'Pet Care',
          'petCareBody': 'Dogs, cats, and other animals',
          'householdServices': 'Household Services',
          'householdServicesBody': 'Cleaning, errands, house sitting, or other services',
          'fallback': 'Care'
        }
      },
      'selectDate': {
        'agencyPrimaryHeading': 'When do you need this care?',
        'agencyConciergeCopy': "Our agency concierge team responds to requests as soon as possible, no later than the next business day. Agency services are not available on New Year's Day, Memorial Day, 4th of July, Labor Day, Thanksgiving Day, or Christmas Day.",
        'heading': 'Select Date',
        'subheading': 'Pick a start and end date/time for this booking.',
        'interviewSubheading': 'Pick a date and time for your interview.',
        'start': 'Starting',
        'end': 'Ending',
        'selectTime': 'Select time',
        'interviewTimes': 'Preferred interview times: {{times}}',
        'perHour': '${{rate}} per hour',
        'fyiHeading': 'FYI',
        'fyiBody': 'One-time bookings exceeding 24 hours are not eligible for flat rate payments. Consider scheduling a recurring booking instead.',
        'unavailable': "Sorry, {{name}} isn't available at this time.",
        'unavailableFallback': "Sorry, this caregiver isn't available at this time.",
        'unavailableSubtitleBooked': 'Please try another date or find other available caregivers.',
        'unavailableSubtitleAnyTime': 'Try another time, send this request anyway for the caregiver to review, or see available caregivers.',
        'unavailableSubtitleGeneric': 'Please try another time, or see other available caregivers.',
        'changeDate': 'Change Date and Time',
        'sendRequestAnyway': 'Send Request Anyway',
        'seeAvailableCaregivers': 'See Available Caregivers',
        'viewAvailability': "View {{name}}'s availability",
        'duration': 'Duration:',
        'bothRequired': 'Please enter both start and end date/time.',
        'endAfterStart': 'End must be after start.'
      },
      'selectMultipleDates': {
        'heading': 'Select dates',
        'start': 'Starting',
        'startPlaceholder': 'When does this start?',
        'end': 'Ending',
        'endPlaceholder': 'When does this end?',
        'startError': 'Start date must be before end date',
        'endError': 'End date should not be more than 12 weeks after the start date.',
        'intervalError': 'No bookable dates fall within the selected schedule.',
        'helperText': 'Based on your start and end date, an editable list of dates will be generated.',
        'daysOfWeekHeading': 'Select Days of the Week',
        'startTimePlaceholder': 'Starting',
        'endTimePlaceholder': 'Ending',
        'dayTimeError': 'End time cannot occur before start time.',
        'next': 'Next, confirm dates'
      },
      'confirmDates': {
        'heading': 'Confirm exact dates',
        'next': 'Next'
      },
      'addDetails': {
        'agencyHeading': 'View details and book',
        'reviewHeading': 'Review details and book {{name}}',
        'dateLabel': 'Date and Time:',
        'datesLabel': 'Dates and Time:',
        'datesRange': '{{count}} dates: Between {{from}} - {{to}}',
        'starts': 'Starts {{date}}',
        'ends': 'Ends {{date}}',
        'changeDateOrTime': 'Change date or time',
        'viewAvailability': "View {{name}}'s availability",
        'describeJob': 'Describe the Job',
        'addJobDescription': 'Add a job description',
        'jobDescription': 'Job Description',
        'jobDescriptionAgency': 'Job description and specific requests for the agency',
        'charactersRemaining': '{{count}} characters remaining',
        'descriptionPlaceholder': 'Anything to add? Caregivers are more likely to accept if you introduce yourself.',
        'descriptionPlaceholderAgency': 'Include anything the agency should know such as the children’s names, allergies, and/or special needs',
        'descriptionPlaceholderHousehold': 'Caregivers appreciate a brief description of the services required such as housesitting, laundry, light cleaning, etc.',
        'descriptionRequired': 'Please enter a description.',
        'noContact': 'Please do not include contact information',
        'jobIncludes': 'Job includes',
        'sweetenDeal': 'Sweeten the deal',
        'jobDetails': 'Job Details',
        'children': 'Children',
        'pets': 'Pets',
        'receivingCare': 'Receiving Care',
        'age': 'Age',
        'ages': 'Ages',
        'kidsAgesError_one': 'Tell us how old the child is.',
        'kidsAgesError_other': 'Tell us how old the children are.',
        'petTypePrompt_one': 'Click to select your pet type',
        'petTypePrompt_other': 'Click to select your pet types',
        'dog': 'Dog',
        'cat': 'Cat',
        'otherPet': 'Other',
        'caregiverRatesHeading': 'Caregiver rates',
        'petRateLine_one': '{{displayCount}} pet: {{rateRange}}/hr',
        'petRateLine_other': '{{displayCount}} pets: {{rateRange}}/hr',
        'paymentType': 'Payment type',
        'payment': 'Payment',
        'rateAriaLabel': 'Rate type',
        'postedJobRate': 'Posted job rate: ${{rate}}/hr',
        'minimumAllowedRateHelper': 'Minimum allowed rate: ${{rate}}/hr',
        'lastPaidRateHelper': 'Last paid rate: ${{rate}}/hr',
        'caregiverMinimumRateHelper': "Caregiver's minimum rate: ${{rate}}/hr",
        'caregiverTypicalMinimumHelper': 'Caregiver typically charges a minimum of ${{rate}}/hr',
        'rateMustBeAtOrAbove': 'Rate must be at or above ${{rate}} to continue',
        'rateMustBeAtOrBelow': 'Rate must be at or below ${{rate}} to continue',
        'sitterMinimumRateBannerTitle': 'FYI',
        'sitterMinimumRateBanner': "This caregiver's minimum rate is ${{rate}}",
        'previousRateBelowMinimumBannerTitle': 'SITTER UPDATE',
        'previousRateBelowMinimumBanner': 'This caregiver previously agreed to work with your family for less than what they usually charge: ${{rate}}',
        'selectFrequency': 'Payment frequency',
        'perHourOption': 'Rate per hour',
        'flatRateOption': 'Flat rate per shift',
        'hourly': 'Hourly',
        'paymentMethod': 'Payment method',
        'creditCard': 'Credit card',
        'creditCardFeeTooltip': "Credit card payments are subject to a 3% platform fee. Rest assured, caregivers keep 100% of their earnings with UrbanSitter's standard payouts.",
        'employerCreditTooltip': "Employer-sponsored care credit is available for this booking. Eligible services must meet your employer's policy.",
        'voucherNoteCreditAccepted': 'To pay with a caregiving credit code, select the "credit" payment method option',
        'voucherNoteCreditNotAccepted': 'To pay with a caregiving credit code, book a caregiver that accepts credit card payments',
        'cash': 'Cash',
        'creditCardUnavailable': 'Credit payment unavailable',
        'cashOnly': 'Caregiver only accepts cash',
        'locationOfJob': 'Location of Job',
        'street': 'Street',
        'apt': 'Apt #',
        'city': 'City',
        'state': 'State',
        'neighborhood': 'Neighborhood',
        'zipCode': 'Zip code',
        'addressError': 'Please add or correct location information.',
        'phone': 'Phone',
        'phoneShownIfAccepted': 'shown only if accepted',
        'phonePlaceholder': 'xxx-xxx-xxxx',
        'phoneError': 'Please enter a valid phone number.',
        'book': 'Book',
        'mustBeLoggedIn': 'You must be logged in to book. Please refresh and try again.',
        'datesMissing': 'Date and time are missing. Click "Change date or time" to set them.',
        'noRecurringDates': 'No recurring dates were chosen. Click "Change date or time" to add some.',
        'noCaregiverSelected': 'No caregiver selected. Please return to the caregiver search and pick someone.',
        'rateBelowAgreed': 'This caregiver previously agreed to work with your family for ${{minRate}}/hr. Set your rate at or above this to continue.',
        'rateBelowSitterMinimum': "This caregiver's minimum rate for {{count}} {{label}} is ${{minRate}}/hr. Set your rate at or above this to continue.",
        'bookFailed': "Couldn't send booking. Try again.",
        'paywallNeedPayment': 'To complete this booking, add a payment method',
        'paywallNeedPlan': 'To complete this booking, please select a plan',
        'agencyRecipient': 'the agency',
        'caregiverRecipient': 'the caregiver',
        'rateSummaryFlatRate': '${{rate}} flat rate per shift via {{paymentType}}',
        'rateSummaryHourly': '${{rate}}/hr via {{paymentType}}'
      },
      'promo': {
        'title': 'Book a backup?',
        'body': 'Post this job to find backup caregivers — just in case.',
        'noThanks': 'No thanks',
        'postJob': 'Post a job'
      }
    },
    'parentProfile': {
      'heading': "{{name}}'s Profile",
      'dependentsCount_one': '{{count}} dependent',
      'dependentsCount_other': '{{count}} dependents',
      'activeAgo': 'active {{label}}',
      'shareTitle': "{{name}}'s Profile on UrbanSitter",
      'pageTitle': 'UrbanSitter - Family Profile',
      'bookedSitters': {
        'heading': 'Booked Caregivers',
        'seeAll': 'See All'
      },
      'openJobs': {
        'heading': 'Open Job Posts',
        'untitled': 'Job',
        'viaPaymentType': 'via {{paymentType}}'
      },
      'toasts': {
        'linkCopied': 'Link copied to clipboard',
        'shareError': "Couldn't share. Try again.",
        'availabilityHidden': 'Availability hidden from this family.',
        'availabilityShared': 'Availability shared with this family.',
        'availabilityError': "Couldn't update availability. Try again.",
        'reportSubmitted': 'Report submitted. Thank you.',
        'removed': 'Removed.',
        'removeError': "Couldn't remove. Try again.",
        'added': 'Added.',
        'addError': "Couldn't add. Try again."
      },
      'aria': {
        'changePhoto': 'Change profile picture',
        'state': 'State',
        'report': 'Report'
      },
      'placeholders': {
        'phone': 'xxx-xxx-xxxx',
        'birthMonth': 'Birth month (1-12)',
        'birthYear': 'Birth year',
        'allergies': 'Allergies (optional)',
        'street': 'Street',
        'apt': 'Apt #',
        'city': 'City',
        'state': 'State',
        'zip': 'ZIP',
        'neighborhood': 'Neighborhood',
        'petDetails': 'Add any details such as the number, size, or personality of your pets…',
        'searchSchool': 'Search for a school',
        'searchAffiliations': 'Search affiliations',
        'searchLocalGroups': 'Search local groups'
      },
      'contacts': {
        'emergencyHeading': 'Emergency contact',
        'pediatricianHeading': 'Pediatrician'
      },
      'editKid': {
        'dependent': 'Dependent {{number}}',
        'addAnother': 'Add another dependent',
        'additionalConsiderations': 'Additional considerations',
        'emptyState': 'No dependents yet. Add one to get started.'
      },
      'editModal': {
        'done': 'Done',
        'cancel': 'Cancel',
        'save': 'Save'
      },
      'associations': {
        'searching': 'Searching…',
        'noMatches': 'No matches.',
        'removeAriaLabel': 'Remove {{name}}',
        'addSchoolLabel': 'Add a school',
        'addAffiliationLabel': 'Add an affiliation',
        'addLocalGroupLabel': 'Add a local group',
        'schoolsEmpty': "You aren't associated with any schools yet.",
        'groupsEmpty': "You aren't in any groups yet."
      },
      'tooltips': {
        'hideAvailability': "If you'd prefer not to get booking requests from this family, you can hide your availability."
      },
      'buttons': {
        'hideAvailability': 'Hide Availability',
        'shareAvailability': 'Share Availability'
      },
      'sections': {
        'children': 'Edit dependents',
        'address': 'Home address',
        'contacts': 'Emergency contacts',
        'languages': 'Languages spoken',
        'pets': 'Edit pets',
        'localGroups': 'Local Groups'
      },
      'flagModal': {
        'title': 'Report this family',
        'inappropriateOffensive': 'This profile is inappropriate or offensive',
        'misleadingSuspicious': 'This profile is misleading or suspicious',
        'poorExperience': 'I had a poor experience with this individual',
        'discriminatory': 'This individual or their profile is discriminatory',
        'other': 'Other',
        'submit': 'Submit Report',
        'details': 'Details',
        'intro': 'Your feedback is anonymous and helps us keep the community safe.',
        'reasonRequired': 'Please choose a reason.',
        'submitError': "Couldn't submit report. Try again."
      },
      'photo': {
        'tooLarge': 'Photo must be under 10 MB.',
        'uploadFailed': "Couldn't upload photo. Try again.",
        'tips': 'Photo tips'
      },
      'sectionTitles': {
        'children': 'Edit dependents',
        'address': 'Home address',
        'parking': 'Parking',
        'contacts': 'Emergency contacts',
        'languages': 'Languages spoken',
        'pets': 'Pets',
        'schools': 'Schools',
        'groups': 'Groups'
      },
      'familyDetails': {
        'kidsSchoolsHeading': "Kid's Schools",
        'heading': 'Family Details',
        'privacyNote': 'These details are only shared with caregivers you choose to book',
        'dependentsHeading': 'Dependents',
        'noDependents': 'No dependents yet.',
        'ageLabel': 'Age: ',
        'allergiesLabel': 'Allergies: ',
        'addressHeading': 'Home Address',
        'neighborhoodLabel': 'Neighborhood: ',
        'parkingAreaQuestion': 'Is there ample parking in your area?',
        'sitterParkingQuestion': 'Do you have a parking spot that the caregiver can use?',
        'contactsHeading': 'Emergency Contacts',
        'emergencyContactLabel': 'Emergency contact: ',
        'pediatricianLabel': 'Pediatrician: ',
        'languagesHeading': 'Languages Spoken',
        'noLanguages': 'None specified',
        'noSchools': 'None yet',
        'noGroups': 'None yet'
      },
      'learnMore': 'Learn More',
      'badges': {
        'title': 'Badges',
        'empty': 'No badges yet.'
      },
      'groups': {
        'title': 'Groups',
        'empty': 'No groups yet.',
        'localGroups': 'Local Groups',
        'affiliations': 'Affiliations',
        'schools': 'Schools'
      },
      'feedback': {
        'title': 'Caregiver Feedback',
        'noRecommendations': 'No recommendations yet',
        'recommendPercent': '{{rating}}% of caregivers recommend {{name}}',
        'basedOnFeedback_one': 'Based on feedback from {{count}} caregiver',
        'basedOnFeedback_other': 'Based on feedback from {{count}} caregivers',
        'seeMore': 'See More',
        'seeMoreLink': 'See more'
      },
      'feedbackModal': {
        'title': "{{name}}'s Reviews",
        'seeAllReviews': 'See all reviews',
        'soundsGood': 'Sounds good',
        'fyi': 'FYI',
        'recommendPercentBanner': '{{rating}}% of caregivers recommend working with {{name}}',
        'basedOnFeedback_one': 'Based on feedback from {{count}} caregiver',
        'basedOnFeedback_other': 'Based on feedback from {{count}} caregivers',
        'noneTitle': '{{name}} has no feedback yet.',
        'noneBody': "Once caregivers review {{name}}, you'll see reviews here.",
        'noneImageAlt': 'Background-checked sitters',
        'positiveHeading': "According to your caregivers, you're awesome!",
        'preferBody': 'Caregivers tell us they prefer working with, and returning to, families that:',
        'respectTime': 'Respect their time',
        'accurateDuties': 'Accurately describe job duties',
        'payAgreements': 'Pay based on booking agreements',
        'negativeHeading': 'Caregivers prefer working with families that:',
        'negativeBody': "If you've been reviewed by a caregiver who wasn't a good fit, don't worry — many caregivers tell us they'll overlook a single negative review when the job otherwise looks like a great match."
      },
      'reviewFaqModal': {
        'title': 'Building Confidence',
        'subheading': 'A new way for caregivers to share feedback',
        'prefersIntro': 'Caregivers tell us they prefer working with families that:',
        'whyLabel': 'Why?',
        'whyBody': 'We asked caregivers what would make them more confident in accepting jobs. The ability to review employers was their #1 request to help build trust.',
        'howLabel': 'How?',
        'howBody': 'After working with families, caregivers will be asked whether they recommend the family to other caregivers. Simple yes or no feedback, pretty straightforward.',
        'expectLabel': 'What can I expect for my family?',
        'expectBody': "Caregivers have been able to share feedback on families privately with UrbanSitter for the last five years. 96% of that feedback has been positive, so we're confident the feedback will only boost your family's success in finding care.",
        'negativeLabel': 'What happens if I get a negative review?',
        'negativeExplain': "We spoke with a lot of caregivers and many said they would overlook a negative review if the job otherwise seems like a great fit for them. Our goal is to help caregivers feel safe and know what to expect from a new family. Caregivers aren't perfect and they don't expect families to be, either!",
        'soundsGood': 'Sounds Good',
        'imageAlt': 'Caregiver helping child buckle helmet'
      }
    },
    'savedSearches': {
      'heading': 'Pick up where you left off',
      'openSearchesHeading': 'Open Searches',
      'loading': 'Loading caregivers...',
      'emptyHeading': "You haven't saved any part-time or full-time searches.",
      'emptyBody': 'When you start a new search, remember to select "Save Search" to find it here.',
      'savedOn': 'Saved {{date}}',
      'filters_one': '{{count}} filter:',
      'filters_other': '{{count}} filters:',
      'filters': '{{count}} filters:',
      'emailNotifications': 'Email notifications:',
      'notificationsLoading': 'Loading…',
      'startNewHeading': 'Start a new search',
      'typeChild': 'Childcare',
      'typeSenior': 'Senior Care',
      'typePet': 'Pet Care',
      'typeHousehold': 'Household Services',
      'deleteModalTitle': 'Why are you deleting this search?',
      'reasonPrompt': 'Select a reason',
      'reasonFoundCaregiver': 'Found a caregiver',
      'reasonNoLongerNeed': 'No longer need care',
      'reasonTooManyEmails': 'Too many emails',
      'reasonOther': 'Other',
      'closeReasonDescriptionLabel': 'Anything you want to share with our team?',
      'closeReasonDescriptionPlaceholderRequired': 'Please tell us why',
      'closeReasonDescriptionPlaceholderOptional': 'Optional',
      'closeSuccess': 'Search closed.',
      'closeError': "Couldn't close search. Try again.",
      'notificationsError': "Couldn't update notifications.",
      'viewSearch': 'View Search',
      'resumeModal': {
        'title': 'Would You Like to Pick Up Where You Left Off?',
        'startNew': 'Start a New Search'
      },
      'recurringModal': {
        'title': 'Save Search',
        'searchTitleTemplate': '{{type}} Search',
        'addressHeading': 'Street Address:',
        'addressHint': 'Used to calculate distance.',
        'notifyHeading': 'Get Notified of New Matches',
        'emailLabel': 'Email:',
        'continue': 'Continue',
        'addressRequired': 'Address is required',
        'createError': "Couldn't start this search. Please try again."
      },
      'filterSummary': {
        'availableSelectedDays': 'Available selected days',
        'distance_one': '{{count}} mile',
        'distance_other': '{{count}} miles',
        'rateUnder': 'Under ${{rate}}/hr',
        'children_one': '{{count}} child',
        'children_other': '{{count}} children',
        'children_max': '4+ children',
        'pets_one': '{{count}} pet',
        'pets_other': '{{count}} pets',
        'pets_max': '4+ pets',
        'seniors_one': '{{count}} senior',
        'seniors_other': '{{count}} seniors',
        'seniors_max': '4+ seniors',
        'activeWithin': 'Active {{period}}',
        'acceptsCreditCard': 'Accepts credit card',
        'willingToDriveChildren': 'Willing to drive kids',
        'hasCar': 'Has a car',
        'respondsQuickly': 'Responds quickly',
        'backgroundCheck': 'Has done a background check',
        'experienceWith': 'Has experience with {{list}}',
        'speaks': 'Speaks {{list}}',
        'dogs': 'dogs',
        'cats': 'cats',
        'otherPets': 'other pets',
        'householdServices': 'household services',
        'worksWith': 'Works with {{list}}'
      }
    },
    'sitters': {
      'heading': 'Search by Date and Time',
      'searchTitle': {
        'daycare': 'Daycare & Preschool Search',
        'fullTime': 'Full-time Search',
        'partTime': 'Part-time Search',
        'default': 'Search by Date and Time'
      },
      'pageOf': 'Page {{current}} of {{total}}',
      'nullHeading': 'No caregivers found',
      'nullBody': 'Try adjusting your filters or expanding your search area.',
      'nullState': {
        'daycare': {
          'title': 'No exact matches found',
          'text': 'Try using fewer filters or searching for one child at a time. Still no luck? You could also post a job to find the perfect sitter or nanny.',
          'cta': 'Post a job'
        },
        'passed': {
          'title': "You haven't passed on any caregivers who match this search."
        },
        'default': {
          'title': "We're having trouble finding a match",
          'text': 'Try fewer filters, or post a job and caregivers will reach out to you.',
          'cta': 'Post to Caregivers'
        }
      },
      'sortLabel': 'Sort by',
      'sort': {
        'bestMatch': 'Best match',
        'rate': 'Lowest rate',
        'reviews': 'Most reviews',
        'connections': 'Connected to me',
        'distance': 'Closest distance'
      },
      'postAJob': 'Post a Job',
      'postSearchLine1': 'Find a mutual match quickly!',
      'postSearchLine2': "Post your search details to our caregiver community to see who's interested.",
      'postToCaregivers': 'Post a job to the sitter community.',
      'bookDatesCta': 'Book Dates',
      'results_one': '{{count}} result',
      'results_other': '{{count}} results',
      'candidateTypes': {
        'all': 'All',
        'passed': 'Passed'
      },
      'savedFiltersLabel_one': 'Saved: {{count}} filter',
      'savedFiltersLabel_other': 'Saved: {{count}} filters',
      'careTypeAriaLabel': 'Care type',
      'allCaregivers': 'All caregivers',
      'filtersButton': 'Filters',
      'typeOfJobLabel': 'Type of job:',
      'verticals': {
        'childCare': 'Sitters, nannies, & backup care',
        'dayCare': 'Daycares & preschools',
        'petCare': 'Pet care',
        'seniorCare': 'Senior care',
        'householdServices': 'Household services'
      },
      'saveSearchToast': {
        'success': 'Search saved.',
        'error': "Couldn't save search. Try again."
      },
      'saveSearchModal': {
        'title': 'Save Search',
        'intro': "Save your filters to quickly run this search later. We'll email you when new caregivers match.",
        'nameLabel': 'Name:',
        'namePlaceholder': 'After-school help',
        'defaultTitle': {
          'daycare': 'Daycare & Preschool Search',
          'fullTime': 'Full-time Search',
          'partTime': 'Part-time Search',
          'default': 'Search by Date and Time'
        },
        'notifyHeading': 'Get notified of new matches',
        'emailLabel': 'Email:',
        'modeLegend': 'Save type',
        'updateOption': 'Update this search',
        'newOption': 'Save as a new search',
        'appliedFilters': 'Applied Filters ({{count}})',
        'typeOfCare': 'Type of care:',
        'typeOfJob': 'Type of job:',
        'locationLabel': 'Location:',
        'distanceLabel': 'Distance:',
        'distanceMiles_one': '{{count}} mile',
        'distanceMiles_other': '{{count}} miles',
        'numberReceivingCare': 'Number receiving care:',
        'rateLabel': 'Rate:',
        'rateUnder': 'under ${{rate}}/hr'
      },
      'availableDate': {
        'label': 'Available:',
        'startingLabel': 'Starting:',
        'endingLabel': 'Ending:',
        'startDatePlaceholder': 'Start date',
        'startTimePlaceholder': 'Start time',
        'endDatePlaceholder': 'End date',
        'endTimePlaceholder': 'End time',
        'change': 'Change',
        'clear': 'Clear',
        'endAfterStart': 'End time must be after start time.'
      },
      'agencyCard': {
        'title': 'Agency Care',
        'subtitle': 'Let us handle everything!',
        'details': 'UrbanSitter partners with top care agencies to send the best vetted caregiver for your needs straight to you for a simple, stress-free experience.',
        'button': 'Learn more'
      },
      'requestMorePrompt': 'Not seeing enough caregivers? We want to hear from you.',
      'requestMoreDaycarePrompt': 'Not seeing enough daycares or preschools? We want to hear from you.',
      'requestMoreLink': 'Let us know',
      'requestMoreThanks': "Thanks! We've let our recruiting department know.",
      'requestMoreThenPost': 'Meanwhile, try posting to our Job Board, where additional caregivers can see the job and apply.',
      'requestMoreThenPostDaycare': 'Meanwhile, you can post a job to find the perfect sitter or nanny.',
      'postJob': 'Post a job',
      'submitting': 'Submitting...',
      'filters': {
        'distance': 'Distance',
        'anyDistance': 'Any distance',
        'distanceOption_one': '{{count}} mile',
        'distanceOption_other': '{{count}} miles',
        'rateMaximum': 'Maximum rate',
        'ratePerHour': 'Rate per hour',
        'perMonth': 'per month',
        'perHour': 'per hour',
        'clear': 'Clear',
        'setMaximum': 'Set Maximum',
        'showRatesFor': 'Show rates for',
        'childCountAny': 'Any',
        'childCount_one': '{{count}} child',
        'childCount_other': '{{count}} children',
        'trustAndSafety': 'Trust & safety',
        'backgroundCheck': 'Completed background check',
        'respondsQuickly': 'Responds quickly',
        'transportation': 'Transportation',
        'hasCar': 'Has a car',
        'willingToDriveChildren': 'Willing to drive children',
        'worksWith': 'Works with',
        'infants': 'Infants (under 1 year)',
        'toddlers': 'Toddlers (1-3 years old)',
        'schoolAge': 'School age (4+ years old)',
        'dogs': 'Dogs',
        'cats': 'Cats',
        'otherAnimals': 'Other animals',
        'preferences': 'Preferences',
        'acceptsCreditCard': 'Accepts credit card',
        'excludeFavorites': 'Exclude my favorites',
        'languagesTitle': 'Languages:',
        'teachingSkillsTitle': 'Teaching Skills:',
        'specialSituationsTitle': 'Special Situations:',
        'willingToHelpWith': 'Willing to help with:',
        'experienceWith': 'Experience with:',
        'location': {
          'title': 'Location',
          'zipCode': 'Zip code',
          'city': 'City',
          'state': 'State',
          'street': 'Street',
          'setLocation': 'Set Location',
        },
      },
    },
    'sittersEditAvailability': {
      'title': 'Select the blocks of time you need',
      'generallyAvailable': 'Generally available:',
      'showOnlyExactMatches': 'Show only exact matches',
      'am': 'AM',
      'pm': 'PM',
      'night': 'Night',
      'morningDescription': 'early morning to mid-day',
      'afternoonDescription': 'mid-day to evening',
      'nightDescription': 'evening to nighttime',
      'morningAriaLabel': 'Require {{day}} morning availability',
      'afternoonAriaLabel': 'Require {{day}} afternoon availability',
      'nightAriaLabel': 'Require {{day}} night availability',
      'postJobPrefix': 'To add more specific times,',
      'postJobLink': 'post a job to the sitter community.'
    },
    'settings': {
      'sections': {
        'accountBasics': 'Account Basics',
        'communication': 'Communication',
        'socialConnections': 'Social Connections',
        'expandAriaLabel': 'Expand {{title}}',
        'collapseAriaLabel': 'Collapse {{title}}'
      },
      'rowHeadings': {
        'membershipPlan': 'Membership plan',
        'nextBillingDate': 'Next Billing Date',
        'identityCheck': 'Identity check',
        'email': 'Email',
        'password': 'Password',
        'mobilePhone': 'Mobile phone (optional)',
        'newsletter': 'Newsletter',
        'friendsOnUS': 'Friends on UrbanSitter',
        'schools': 'Schools',
        'affiliations': 'Affiliations',
        'localGroups': 'Local Groups',
        'savedSearches': 'Saved Searches',
        'facebook': 'Facebook',
        'google': 'Google'
      },
      'fields': {
        'emailAriaLabel': 'Email address',
        'currentPasswordAriaLabel': 'Current password',
        'currentPasswordPlaceholder': 'Verify current password',
        'newPasswordPlaceholder': 'Enter your new password',
        'repeatPasswordPlaceholder': 'Repeat your new password'
      },
      'loading': 'Loading...',
      'savedToast': 'Settings saved.',
      'saveError': "Couldn't save settings. Try again.",
      'joinedOn': 'Joined {{date}}',
      'saveChangesCta': 'Save Changes',
      'membership': {
        'noPlanLabel': 'None',
        'addPlanCta': 'Add a plan',
        'activeUntil': 'Active until {{date}}',
        'changeOrCancelCta': 'Change or Cancel Membership'
      },
      'communicationDisclaimer': 'Please note that independent of your selections below you will still receive emails related to any job posts, messages, bookings, or purchases you initiate on UrbanSitter.',
      'newsletterCheckboxLabel': 'Send me a weekly newsletter',
      'friendsCheckboxLabel': 'Send me emails when friends leave a 5-star review',
      'schoolsCheckboxIntro': 'Send me emails when someone from these schools leaves a 5-star review',
      'affiliationsCheckboxIntro': 'Send me emails when someone from these affiliations leaves a 5-star review',
      'localGroupsCheckboxIntro': 'Send me emails when someone from these groups leaves a 5-star review',
      'savedSearchFallbackTitle': 'Search #{{id}}',
      'manageSavedSearchesLink': 'Manage saved searches',
      'changePasswordCta': 'Change Password',
      'createPasswordCta': 'Create Password',
      'phoneConsentBody': 'By providing your mobile phone number, you consent to UrbanSitter sending you text message communications. Your number will be shared only with caregivers you choose to book, and as otherwise permitted in our',
      'facebookSdkUnavailable': 'Facebook SDK not available. Please try again.',
      'connectFacebook': 'Connect with Facebook',
      'facebookConnectBody': 'Connect to see recommendations from people you know.',
      'google': {
        'linkFailed': 'Google account linking failed.',
        'linkSuccess': 'Google successfully connected.',
        'linkError': "Couldn't link Google. Try again."
      },
      'planModal': {
        'cancelHeading': 'Cancel membership',
        'cancelBody': 'Are you sure you want to cancel your membership? You will lose access at the end of your current billing cycle.',
        'cancelCta': 'Cancel membership',
        'changeHeading': 'Change membership plan',
        'changeIntro': 'Pick a new plan below.',
        'termsBody': 'Auto-renewal, payment, subscription, cancellation, and refund policies apply.',
        'termsCheckbox': 'I have reviewed and agree to these policies.',
        'acceptTerms': 'You must accept the terms to continue.',
        'planUpdated': 'Plan updated.',
        'planUpdateError': "Couldn't update plan. Try again.",
        'canceledLabel': 'Canceled',
        'currentLabel': '(current)',
        'termsOfServiceLinkText': 'Terms of Service'
      },
      'privacy': {
        'heading': 'Privacy Settings',
        'description': 'Allow other families to see a list of the caregivers you book on your profile.',
        'showBookedCaregivers': 'Show booked caregivers'
      },
      'verification': {
        'completed': 'Completed',
        'completeCheck': 'Complete an identity check',
        'contactSupportPrefix': 'Please contact',
        'contactSupportSuffix': 'for help'
      },
      'upsell': {
        'heading': 'Get more from UrbanSitter',
        'upgrade': 'Upgrade now',
        'getAPlan': 'Get a plan',
        'fallbackBullet1': 'Message and book sitters faster.',
        'fallbackBullet2': 'Unlock private notes, recommendations, and more.',
        'fallbackBullet3': 'Cancel anytime.'
      }
    },
    'calendar': {
      'lastUpdate': 'Last updated {{date}}',
      'today': 'Today',
      'previousLabel': 'Previous {{unit}}',
      'nextLabel': 'Next {{unit}}',
      'unitDay': 'day',
      'unitWeek': 'week',
      'unitMonth': 'month',
      'viewDay': 'Day',
      'viewWeek': 'Week',
      'viewMonth': 'Month',
      'settingsAria': 'Calendar settings',
      'noUpcoming': 'No upcoming availability.',
      'noUpcomingFor': '{{name}} does not show availability at this time. Send a request to confirm availability.',
      'upcoming': 'Upcoming',
      'available': 'Available',
      'availableShort': 'Avail',
      'booking': 'Booking',
      'booked': 'Booked',
      'midnightPlus': 'midnight+',
      'moreEntries': '+{{count}} more',
      'previousMonth': 'Previous month',
      'nextMonth': 'Next month',
      'timeGridAria': 'Time grid',
      'goToDay': 'Go to day',
      'addOnDateAriaLabel': 'Add on {{date}}',
      'ratingAria': 'Rating {{rating}}',
      'bookingRequest': 'Booking request',
      'jobAccepted': 'Job Accepted',
      'jobCompleted': 'Job Completed',
      'jobRequest': 'Job Request',
      'interviewAccepted': 'Interview Accepted',
      'interviewCompleted': 'Interview Completed',
      'interviewRequest': 'Interview Request',
      'upcomingBooking': 'Upcoming booking',
      'profilePhotoFor': '{{name}} profile',
      'ratePerHour': '${{rate}}/hr',
      'childCount_one': '{{count}} child',
      'childCount_other': '{{count}} children',
      'kidsAgesParenthetical': '({{ages}})',
      'payVia': 'Pay via {{paymentType}}',
      'viewRequest': 'Respond to Request',
      'viewBooking': 'See Booking Details',
      'requestABooking': 'Request a Booking',
      'message': 'Message',
      'interview': 'Interview',
      'respondsIn_one': 'Responds in 1 hour',
      'respondsIn_other': 'Responds in {{count}} hours',
      'reviewsAndRepeats': '{{reviews}} | {{repeats}}',
      'reviewsCount_one': '1 review',
      'reviewsCount_other': '{{count}} reviews',
      'repeatFamiliesCount_one': '1 repeat family',
      'repeatFamiliesCount_other': '{{count}} repeat families',
      'loading': 'Loading...',
      'hideConfirmTitle': 'Hide this caregiver?',
      'showConfirmTitle': 'Show this caregiver?',
      'hideConfirmBody': 'This caregiver will no longer appear in your search results.',
      'showConfirmBody': 'You will see this caregiver in search results again.',
      'hideConfirmLabel': 'Hide',
      'showConfirmLabel': 'Show'
    },
    'sitterProfile': {
      'availability': {
        'heading': 'Availability',
        'snapshotHeading': 'Job seeking snapshot:',
        'takingBreak': 'Taking a break?',
        'updated': 'Availability updated'
      },
      'rates': translation.components.sitterProfile.rates,
      'labels': translation.components.sitterProfile.labels,
      'modals': {
        'editLanguages': 'Edit languages',
        'editTeachingSkills': 'Edit teaching skills',
        'editSpecialExperience': 'Edit special experience',
        'editSpecialServices': 'Edit special services',
        'editSpecialSituations': 'Edit special situations',
        'editOtherServices': 'Edit other services',
        'editRates': 'Edit rates',
        'editLocation': 'Edit location',
        'editCertifications': 'Edit certifications',
        'editEducation': 'Edit education',
        'editAgeExperience': 'Edit your experience with different age groups',
        'covidConsent': 'COVID-19 consent'
      }
    },
    'groups': {
      'pageTitle': 'UrbanSitter - Caregivers',
      'loading': 'Loading caregivers...',
      'noMatchHeading': 'We’re having trouble finding a match.',
      'noMatchBody': 'Try fewer filters or',
      'goToFullSearch': 'go to full search',
      'noMatchAfter': 'to find caregivers who match all of these filters.',
      'disclaimerPrefix': 'These caregivers are recommended by families affiliated with {{name}}.',
      'disclaimerMiddle': 'UrbanSitter is not sponsored or endorsed by {{name}}. {{name}} does not recommend or endorse any caregiver on UrbanSitter.',
      'disclaimerFamily': "UrbanSitter has not independently verified any family's affiliation with {{name}}.",
      'disclaimerCaregiver': "UrbanSitter has not independently verified any caregiver's affiliation with {{name}}.",
      'previous': 'Previous',
      'next': 'Next',
      'pageOf': 'Page {{current}} of {{total}}',
      'filters': 'Filters',
      'heroHeading': 'Meet the caregivers recommended by families affiliated with {{name}}',
      'heroSubtitle': 'Family recommended caregivers',
      'heroHeadingLocal': 'Meet caregivers recommended by {{name}}',
      'heroSubtitleLocal': 'Caregivers recommended by {{name}}',
      'collegeHeading': 'Babysitters: {{name}}',
      'collegeSubtitle': 'Available Babysitters attending or graduates of {{name}}',
      'friendsHeading': 'Caregivers your friends recommend',
      'shareWithFriends': 'Share with friends',
      'linkCopied': 'Link copied to clipboard',
      'addToYourGroups': 'Add to your groups',
      'addedToGroupsToast': '{{name}} added to your groups',
      'addToGroupsError': 'Failed to add {{name}} to your groups. Please try again.',
      'careTypeAriaLabel': 'Type of care',
      'typeOfJobLabel': 'Type of job:',
      'sortLabel': 'Sort by',
      'sort': {
        'bestMatch': 'Best match',
        'rate': 'Lowest rate',
        'reviews': 'Most reviews',
        'connections': 'Connected to me',
        'distance': 'Closest distance',
      },
      'resultsCount': '{{count}} caregiver',
      'resultsCount_other': '{{count}} caregivers',
    },
  },
  'notifications': {
    'feedback': {
      'success': 'Thanks for your feedback!',
    },
    'facebook': {
      'success': 'Facebook successfully connected.',
      'error': 'Unable to link Facebook account. Please try again or contact support.',
    },
  },
  'validation': translation.validation,
}
